import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class CloudAccount extends MongoEntity {
  static override _class = 'CloudAccount';
  static override _collectionName = 'cloud_accounts';

  @Field(type => String) userId!: string;
  @Field(type => String) provider!: 'google_drive' | 'onedrive';
  @Field(type => String) email!: string;
  @Field(type => String) displayName!: string;
  @Field(type => String) encryptedRefreshToken!: string;
  @Field(type => String) connectedAt!: string;
}
